import { UserSkill } from './user-skills.model';

export interface GenerateUserSkillOptions {
  readonly userId: number;
  readonly skills?: ReadonlyArray<number>;
}

export function generateUserSkillObject({
  userId,
  skills = [],
}: GenerateUserSkillOptions): UserSkill {
  return {
    id: userId,
    skills,
  };
}
